
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"42","height":"45","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.415.938a4.905 4.905 0 00-2.358 9.205l-9.95 24.38a4.906 4.906 0 00-4.128.427L9.404 22.845a4.897 4.897 0 10-1.307 1.143l10.575 12.106a4.884 4.884 0 00-1.075 3.063c0 2.709 1.924 4.904 4.904 4.904s4.904-2.195 4.904-4.904a4.892 4.892 0 00-1.773-3.774l10.075-24.688a4.902 4.902 0 005.6-4.497 4.903 4.903 0 00-4.892-5.26z","fill":"#ABAFB5"}})])
          )
        }
      }
    